import type { NavigationBadge } from '../../types/navigation'
import { Badge } from '../common/Badge'

export default function BadgeWithText({ badge, text }: { badge?: NavigationBadge; text: string }) {
  return (
    <>
      {text}
      {badge && (
        <>
          &nbsp;
          <Badge badge={badge} />
        </>
      )}
    </>
  )
}
